export default function LoadingButton(theme) {
	return {
		MuiLoadingButton: {
			styleOverrides: {
				root: {}
			}
		}
	};
}
